<!-- 映射管理 -->
<template>
    <router-view v-if="$route.path !== '/correspondence'"></router-view>
    <div class="practical-table" v-else ref="scrollableDiv">
        <div class="container card">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="瑕疵映射" name="third"> </el-tab-pane>
            </el-tabs>
        </div>
        <FixedButtons @scroll-to-top="_scrollToTop" />
    </div>
</template>

<script>
import FixedButtons from "@/components/FixedButtons.vue";
import { scrollToTop } from "@/utils/utils";
import axios from "axios";

export default {
    name: "PracticalTableView",
    components: { FixedButtons },
    data() {
        return {
            props: { multiple: true, label: "paramValue", value: "看后端传来的" },

            //查询各平台
            platformURL: "/api/systemConfig/queryBySystemConfigSearchDTO",

            // 查询各平台的品牌
            platformBrand: "/api/ProductBrandMapping/init",

            // 查询系统品牌
            sysBrand: "/api/ProductBrand/init",

            // 新增时候系统品牌查询
            addSysBrand: "/api/ProductBrand/queryDataByParam",

            // 分页查询其他平台品牌映射到系统品牌数据
            productBrandMapping: "/api/ProductBrandMapping/queryDataByParam",

            // 添加品牌映射关系
            addBrandMapping: "/api/ProductBrandMapping/insertBrandMapping",

            // 编辑品牌映射关系
            editBrandMapping: "/api/ProductBrandMapping/update",

            // 删除品牌映射关系
            deleteBrandMapping: "/api/ProductBrandMapping/deleteBrandMapping",

            //分页查询其他平台机型映射到系统机型数据
            correspondence: "/api/ProductModelMapping/queryModelMappingDataByParam",

            // 添加型号映射关系
            addMapping: "/api/ProductModelMapping/insertModelMapping",

            // 编辑型号映射关系
            editMapping: "/api/ProductModelMapping/update",

            // 删除型号映射关系
            deleteMapping: "/api/ProductModelMapping/deleteModelMapping",

            // 查询平台和机型映射初始化下拉框
            platformModelMapping: "/api/ProductModelMapping/init",

            // 查询系统标准的品牌和机型初始化下拉框
            syspStandardModel: "/api/ProductModel/init",

            // 系统标准型号
            sysModel: "/api/ProductModel/queryDataByParam",

            // 查询瑕疵数据
            flawData: "/api/PlatformDesc/queryDataByParam",

            // 查询瑕疵数据
            flawData: "/api/PlatformDesc/queryDataByParam",

            // 查询下拉框检索数据
            flawSearch: "/api/PlatformDesc/init",

            // 查询下拉框检索数据
            sysStandardFlaw: "/api/PjtDamageStandards/init",

            // 新增瑕疵映射
            addFlawMapping: "/api/PlatformDescReflect/insert",

            // 修改瑕疵映射
            editFlawMapping: "/api/PlatformDescReflect/update",

            // 删除瑕疵映射
            deleteFlawMapping: "/api/PlatformDescReflect/delete",

            // 当前页码
            currentPage: 1,
            // 默认每页显示条目数
            itemsPerPage: 10,
            itemsPerBrandPage: 10,
            itemsPerModelPage: 10,
            itemsPerFlawPage: 10,
            // 总页数
            allPagesBrand: 1,
            allPagesmodel: 1,
            allPagesFlaw: 1,

            BrandReflectShow: true,
            modelReflectShow: false,
            damageReflectShow: false,

            activeName: "first",

            formBrandData: {
                otherBrandName: "", // 其他平台型号
                productBrandName: "", // 系统型号
                sources: "", // 平台
                status: "", // 是否映射
            },
            platformBrandList: [], //平台品牌
            sysBrandList: [], // 系统品牌
            addSysBrandList: [], // 添加时候的系统品牌
            isBrandDialogVisible: false, //新增编辑弹框
            // brandId: '', //新增id
            // productBrandId: '', //新增品牌id
            brandMappingmName: "",
            currentBrandMapping: {
                editId: undefined,
                id: "",
                productBrandId: "",
                brandName: "",
            },
            BrandMappingList: [], //其他平台映射系统平台列表

            formData: {
                brandId: "", //系统品牌id
                otherModelName: "", // 其他平台型号
                productModelName: "", // 系统型号
                sources: "", // 平台
                status: "", // 是否映射
            },
            statusList: [
                { key: "已映射", value: "0" },
                { key: "未映射", value: "1" },
            ],
            platformList: [], // 平台信息
            correspondenceList: [], // 对应信息
            sysPlatformBrandList: [], //系统平台品牌
            sysPlatformModelList: [], //系统平台型号
            otherPlatformModelList: [], // 其他平台型号
            sources: "", //平台
            brandId: "",
            isBrandId: "", //系统平台品牌是否映射过
            isBrandName: "",
            isDialogVisible: false, //新增编辑弹框
            sysModelList: [], // 系统标准型号列表
            otherPlatformName: "",
            currentMapping: {
                editId: undefined,
                id: "",
                brandId: "",
                productModelId: "",
                modelName: "",
                editProductModelId: "",
            },

            formFlawData: {
                descLevel1: "", //一级瑕疵
                descLevel2: "", // 二级瑕疵
                standardsKeyWord: "", // 系统瑕疵
                sources: "", // 平台
                status: "", // 是否映射
            },
            flawDataList: [], // 瑕疵映射列表
            flawOneLevelList: [], //一级瑕疵
            flawTwoLevelList: [], //二级瑕疵
            sysStandardFlawListOne: [], //系统一级瑕疵数据
            sysStandardFlawListTwo: [], //系统二级瑕疵数据
            sysStandardFlawListThree: [], //系统三级瑕疵数据
            isFlawDialogVisible: false, //瑕疵弹框
            currentFlawMapping: {
                editId: undefined,
                id: "",
                sdandardsLevel1: "", //一级名字
                sdandardsLevel2: "", //二级名字
                sdandardsLevel3: "", //三级名字
                otherPlatformDescId: "",
                pjtDescId: "",
            },
            otherPlatformNameFlaw: "",

            rules: {
                modelName: [{ required: true, message: "系统标准型号不能为空", trigger: "blur" }],
            },
        };
    },
    created() {
        this.nickName = localStorage.getItem("nickname") || "";
        this.phone = localStorage.getItem("tel") || "";

        this.getFlawDataList();
        this.getFlawSearchList();
    },
    methods: {
        // 页面顶部
        _scrollToTop() {
            scrollToTop(this.$refs.scrollableDiv);
        },

        handleClick(tab, event) { },
        searchManager() {
            this.getBrandMappingList();
        },

        // 查询平台
        getPlatformList() {
            axios
                .get(this.platformURL, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.platformList = res.data.data.result;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 品牌映射逻辑开始
        //查询平台品牌
        getPlatformBrandList() {
            axios
                .get(this.platformBrand, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.platformBrandList = res.data.data.otherPlatformNameList;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        //查询系统品牌
        getSysBrandList() {
            axios
                .get(this.sysBrand, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.sysBrandList = res.data.data.brandNameList;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        //新增系统品牌查询
        getAddSysBrandList() {
            axios
                .get(this.addSysBrand, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.addSysBrandList = res.data.data;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        selectBrandChange(value) {
            this.currentBrandMapping.productBrandId = value;
        },

        // 新增品牌映射关系
        showBrandAddDialog(row) {
            // currentBrandMapping: {
            //     editId: undefined,
            //     id: "",
            //     productBrandId: "",
            // },
            // brandId: '', //新增id
            // productBrandId: '', //新增品牌id

            this.isBrandDialogVisible = true;
            this.brandMappingmName = row.otherPlatformName;
            this.currentBrandMapping.editId = undefined;
            this.currentBrandMapping.id = row.id;
            this.currentBrandMapping.productBrandId = "";
            this.currentBrandMapping.brandName = "";
            this.getAddSysBrandList();
        },

        // 编辑品牌映射
        showBrandEditDialog(row) {
            this.isBrandDialogVisible = true;
            this.currentBrandMapping.editId = row.id;
            this.currentBrandMapping.id = row.id;
            this.currentBrandMapping.productBrandId = row.productBrandId;
            this.currentBrandMapping.brandName = row.productBrandName;

            this.getAddSysBrandList();
        },

        // 新增保存and编辑保存
        saveBrandMapping() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    if (this.currentBrandMapping.editId === undefined) {
                        const body = { id: this.currentBrandMapping.id, productBrandId: this.currentBrandMapping.productBrandId };
                        axios
                            .post(this.addBrandMapping, body, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.isBrandDialogVisible = false;
                                    this.getBrandMappingList();
                                } else {
                                    this.$message({
                                        message: res.data.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("新增失败", error);
                            });
                    } else {
                        const body = { id: this.currentBrandMapping.id, productBrandId: this.currentBrandMapping.productBrandId };
                        axios
                            .put(this.editBrandMapping, body, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.isBrandDialogVisible = false;
                                    this.getBrandMappingList();
                                    this.currentBrandMapping.productBrandId = "";
                                } else {
                                    this.$message({
                                        message: res.data.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("新增失败", error);
                            });
                    }
                }
            });
        },

        // 删除品牌映射
        handleBrandMappingDelete(row) {
            try {
                this.$confirm("确认删除当前映射吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        axios
                            .delete(this.deleteBrandMapping + `?idList=${row.id}`, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.getBrandMappingList();
                                } else {
                                    this.$message.error(res.data.data);
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("删除失败", error);
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } catch (error) {
                console.error("Failed to delete user:", error);
            }
        },

        // 品牌映射关系列表
        getBrandMappingList() {
            axios
                .get(this.productBrandMapping, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        ...this.formBrandData,
                    },
                })
                .then((res) => {
                    this.allPagesBrand = res.data.data.total;
                    this.BrandMappingList = res.data.data.result;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        sourcesChange(val) {
            this.getPlatformModelMapping(val);
        },
        change(val) { },
        //根据系统品牌查系统型号
        brandChange(val) {
            this.getSyspStandardModel(val);
        },
        selectBrandChange(val) {
            this.getSyspStandardModel(val);
        },
        // 查询平台和机型映射初始化下拉框
        getPlatformModelMapping(val) {
            axios
                .get(this.platformModelMapping, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerModelPage,
                        sources: val,
                    },
                })
                .then((res) => {
                    this.otherPlatformModelList = res.data.data.otherPlatformNameList;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 查询系统标准的品牌和机型初始化下拉框
        getSyspStandardModel(val) {
            axios
                .get(this.syspStandardModel, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerModelPage,
                        brandId: val ? val : this.isBrandId,
                    },
                })
                .then((res) => {
                    if (val) {
                        this.sysPlatformModelList = res.data.data.modelNameList;
                    } else {
                        this.sysPlatformBrandList = res.data.data.brandIdAndNameList;
                        this.sysPlatformModelList = res.data.data.modelNameList;
                    }
                })
                .catch((error) => {
                    this.data = error;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        remoteMethod(query) {
            if (query !== "") {
                // this.getSysModel(query);
            }
        },
        selectChange(val) {
            this.currentMapping.productModelId = val;
        },

        // 型号映射关系列表
        getCorrespondenceList() {
            axios
                .get(this.correspondence, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        ...this.formData,
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerModelPage,
                    },
                })
                .then((res) => {
                    this.allPagesmodel = res.data.data.total;
                    this.correspondenceList = res.data.data.result;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 新增保存and编辑保存
        saveFlawMapping() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    if (this.currentFlawMapping.editId === undefined) {
                        const body = { otherPlatformDescId: this.currentFlawMapping.otherPlatformDescId, pjtDescId: this.currentFlawMapping.pjtDescId };
                        axios
                            .post(this.addFlawMapping, body, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.isFlawDialogVisible = false;
                                    this.getFlawDataList();
                                } else {
                                    this.$message({
                                        message: res.data.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("新增失败", error);
                            });
                    } else {
                        const body = {
                            id: this.currentFlawMapping.id,
                            otherPlatformDescId: this.currentFlawMapping.otherPlatformDescId,
                            pjtDescId: this.currentFlawMapping.pjtDescId,
                        };
                        axios
                            .put(this.editFlawMapping, body, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.isFlawDialogVisible = false;
                                    this.getFlawDataList();
                                    this.currentFlawMapping.pjtDescId = "";
                                } else {
                                    this.$message({
                                        message: res.data.data,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("新增失败", error);
                            });
                    }
                }
            });
        },
        // 删除瑕疵映射
        handleFlawMappingDelete(row) {
            try {
                this.$confirm("确认删除当前瑕疵映射吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        axios
                            .delete(this.deleteFlawMapping + `?idList=${row.platformDescReflectId}`, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.getFlawDataList();
                                } else {
                                    this.$message.error(res.data.data);
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("删除失败", error);
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } catch (error) {
                console.error("Failed to delete user:", error);
            }
        },

        // 瑕疵映射逻辑结束

        // 改变条数
        handleSizeChange(val) {
            this.itemsPerBrandPage = val;
            this.getBrandMappingList();
        },
        //改变页数
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getBrandMappingList();
        },
    },
    watch: {},
    computed: {
        //
    },

    mounted() { },
};
</script>

<style lang="scss" scoped>
/* 表格样式*/
.el-table {
    justify-content: center;
    --el-table-header-bg-color: rgb(107, 107, 107);
    --el-table-text-color: #000000;
    --el-table-border: 1px solid #ebeef5;
    margin-top: 40px;
}

.menu {
    padding-right: 12px;
}

.addone {
    width: 100%;
    justify-content: center;
    display: flex;
    background-color: aliceblue;
    border-radius: 0 0 20px 20px;
}

ul {
    padding: 0;

    li {
        list-style-type: none;
        margin-bottom: 15px;
    }
}

.practical-table {
    width: 100%;
    padding: 20px 40px;
    overflow: auto;
    //color: #ffffff;
}

.card {
    background-color: transparent;
    border: 1px solid transparent;
}

.form-control {
    background-color: #ded9d9;
    margin: 0;
}

.thead-dark {
    background-color: #585d6b;
    color: white;
}

.form-group {
    margin-bottom: 25px;
}

:deep(.tiptop) {
    position: relative;
}

:deep(.tiptop .el-icon) {
    color: #ffffff;
    position: absolute;
    top: -53px;
    left: 215px;
}

:deep(.el-pagination > .is-first) {
    color: #ffffff;
}

:deep(.el-pagination__goto) {
    color: #ffffff;
}

:deep(.el-pagination__classifier) {
    color: #ffffff;
}

:deep(.el-pagination) {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

:deep(.el-form-item__content) {
    width: 160px;
}

:deep(.el-tabs__item) {
    color: #ffffff;
}
</style>
